export type SignatureOptionsGermanVisibility = {
    hasSignature: true;
    isCollectiveSignature: true;
    placeSignatureAfterAop: false;
};
